import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

/**
 * A form version's ACTIVE / INACTIVE lifecycle badge (86eybvqgn criterion D).
 *
 * One component for the Form Definitions table's Status column and the Form
 * Builder's version indicator (z8nrz7dmb1 AC1.3), so the two can never render
 * the same status two ways. `active` absent reads as ACTIVE — the column
 * defaults to true, and the table always treated a missing value that way.
 */
export function FormLifecycleBadge({ active, className }: { active: boolean | undefined; className?: string }) {
  const isActive = active !== false
  return (
    <Badge
      variant='outline'
      className={cn(
        'text-[10px] font-semibold uppercase tracking-wide',
        isActive ? 'border-green-200 bg-green-50 text-green-700' : 'border-red-200 bg-red-50 text-red-600',
        className,
      )}
    >
      {isActive ? 'Active' : 'Inactive'}
    </Badge>
  )
}
